<template>
<v-app>
  <b-overlay variant="white" rounded="sm">
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="kt_wizard_v2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/Shield-protected.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Notificaciones
                  </h3>
                  <div class="wizard-desc">
                   Cargar planilla
                  </div>
                </div>
              </div>
            </div>

           
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="col-12">
              
                <!--begin: Wizard Step 1-->
                  <b-form
                  class="form-signin d-flex align-items-stretch flex-column"
                  @submit.stop.prevent="onSubmit"
                >
                  <div class="datatable-pager datatable-paging-loaded">
                    <h4>Cargar desde archivo</h4>
                    <div class="mt-4">
                      <b-input-group>
                        
                        <b-form-file
                          v-model="$v.form.archivoCargaMasiva.$model"
                          placeholder="Seleccione el archivo .xlsx"
                          id="form-image"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          @change="cargarArchivos($event)"
                          
                        ></b-form-file>
                      </b-input-group>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <button
                          ref="btn_subir_carga"
                          type="submit"
                          class="btn btn-primary"
                   
                        >
                          Enviar Carga Masiva
                        </button>
                      </div>

                     
                    </div>
                  </div>
                </b-form>
                <!--end: Wizard Step 1-->

            </div>
            <!--end: Wizard-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
  </b-overlay>
  <b-modal
      id="modal-detalle-errores"
      title="Erorres Carga Masiva"
      hide-footer
      size="lg"
    >
      <div
        class="alert alert-custom alert-light-danger font-weight-bold py-3"
        v-for="(item, i) in erroresCargaMasiva"
        :key="i"
      >
        <div class="alert-text ">
          Linea {{ item.linea }} - Error: {{ item.mensaje }}
        </div>
      </div>

     
    </b-modal>

</v-app>
</template>
<style lang="scss">
@import "~vuetify/dist/vuetify.css";

.theme--light.v-application {
  background: transparent !important;
}
.v-application code {
  box-shadow: none !important;
}
</style>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>

<script>

import { mapState } from "vuex";
import { CREATE_NOTIFICATIONS } from "@/core/services/store/company.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "Wizard-2",
  data() {
    return {   
      cargaExcelBase64: null,
      erroresCargaMasiva: null,   
      wizard:null,
      switch1: true,
      step:1,
       form: {
        archivoCargaMasiva: null,
      },
    };
  },
  validations: {
    form: {
      archivoCargaMasiva: {
        required,
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Wizard", route: "wizard-1" },
      { title: "Wizard-2" }
    ]);

    // Initialize form wizard
    this.wizard = new KTWizard("kt_wizard_v2", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    this.wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    this.wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  methods: {
    cerrarModalCargaMasiva(){
      this.$bvModal.show("modal-detalle-errores");
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        archivoCargaMasiva: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    makeToast(append = false, texto, titulo, variant) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: variant,
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
   async cargarArchivos(archivo) {
      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      this.cargaExcelBase64 = await toBase64(archivo.target.files[0]);
      console.log('this.cargaExcelBase64 '+ this.cargaExcelBase64);
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const submitButton = this.$refs["btn_subir_carga"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      const contenido = this.cargaExcelBase64;
      console.log(contenido);
      this.$store
        .dispatch(CREATE_NOTIFICATIONS, { contenido })
        // eslint-disable-next-line
        .then((response) => {
          this.makeToast(false, "Carga masiva enviada", "Aviso", "success");
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          this.resetForm()
        })  
        // eslint-disable-next-line
        .catch((response) => {
          console.log(response);
          this.erroresCargaMasiva =
            response.data.cargaMasiva;
          this.$bvModal.show("modal-detalle-errores");
          this.makeToast(
            false,
            "Ha ocurrido un problema al enviar la carga masiva, intente nuevamente",
            "Error",
            "danger"
          );
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  },
  computed: {
    ...mapState({
      errors: state => state.errors,
    })
  }
};
</script>

<style>
.theme--light.v-text-field--solo-inverted.v-input--is-focused > .v-input__control > .v-input__slot {
   background: #fff !important;
   color:#000  !important;
}
.theme--light.v-text-field--solo-inverted > .v-input__control > .v-input__slot {
    background: #fff !important;
   color:#000  !important;
}
.theme--light.v-text-field--solo-inverted.v-input--is-focused > .v-input__control > .v-input__slot input {
    color:#000  !important;
}
</style>